import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getCoustomerAdderss } from "../../../../redux/reduxApi/website/CoustomerAdderssrapi";
// import FiEdit from "react-icons/fi";

// import {
//   setDefaultAddress,
//   deleteAddress,
// } from "../../../../redux/api/website/CoustomerAddressesApi";
import { toast } from "react-toastify";
import {
  deleteCustomerAddresses,
  setDefaultAddress,
} from "../../../../redux/api/website/CoustomerAddressesApi";
import { BsFillTrash2Fill } from "react-icons/bs";
import { Edit, MapPin, Star } from "lucide-react";
// import FaArrowLeft from "@react-icons/all-files/fa/FaArrowLeft";
export default function Addresses() {
  const dispatch = useDispatch();
  const userAddresses = useSelector(
    (state) => state.CoustomerAddress.CoustomerAddress.address || []
  );

  useEffect(() => {
    dispatch(getCoustomerAdderss());
  }, [dispatch]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  };

  const handleSetDefault = async (addressId) => {
    const address = userAddresses.find((addr) => addr.rowId === addressId);

    if (!address) {
      toast.error("Address not found");
      return;
    }

    try {
      // Toggle the default status
      const newDefaultStatus = !address.defaultAddress;

      const res = await setDefaultAddress({
        customerId: localStorage.getItem("customerId"),
        rowId: addressId,
        defaultAddress: newDefaultStatus.toString(),
      });

      console.log(res);

      toast.success(
        newDefaultStatus
          ? "Address set as default successfully"
          : "Default status removed successfully"
      );

      dispatch(getCoustomerAdderss()); // Refresh addresses
    } catch (error) {
      console.error("Error toggling default address:", error);
      toast.error("Failed to update default address");
    }
  };

  const handleDelete = async (addressId) => {
    try {
      // Optimistically update the UI by removing the address immediately
      const updatedAddresses = userAddresses.filter(
        (addr) => addr.rowId !== addressId
      );

      const response = await deleteCustomerAddresses(addressId);
      if (response.data.success) {
        // After successful deletion, fetch the fresh data from the server
        await dispatch(getCoustomerAdderss());
        toast.success("Address deleted successfully");
      }
    } catch (error) {
      // If delete fails, re-fetch to ensure UI is in sync
      dispatch(getCoustomerAdderss());
      toast.error("Failed to delete address");
    }
  };

  return (
    <div className="w-full md:pl-4 md:mt-0 lg:py-[10px] md:py-[10px]">
      <h1 className="lg:text-[40px] md:text-4xl text-3xl font-bold text-blue-900 mb-2 text-center">
        My Addresses
      </h1>
      <hr className="heading-seperator border-4 border-blue-900" />

      <div className="mb-6 flex items-center justify-end">
        <Link to="/account/billing">
          <button className="bg-[#377db9] hover:bg-[#034c8c] text-white px-4 py-2 rounded flex items-center">
            <MapPin className="mr-2" />
            Add New Address
          </button>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {userAddresses.length > 0 ? (
          userAddresses.map((address) => (
            <div
              key={address.rowId}
              className={`border rounded-lg p-4 shadow-md ${address.defaultAddress
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-200"
                }`}
            >
              <div className="flex justify-between items-start mb-2">
                <div className="flex items-center">
                  <h3 className="font-bold text-lg capitalize">
                    {address.addressType} Address
                  </h3>
                  {address.defaultAddress && (
                    <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                      Default
                    </span>
                  )}
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => handleSetDefault(address.rowId)}
                    className={`p-1 rounded ${address.defaultAddress
                        ? "text-yellow-500"
                        : "text-gray-400 hover:text-yellow-500"
                      }`}
                    title={
                      address.defaultAddress
                        ? "Default address"
                        : "Set as default"
                    }
                  >
                    <Star
                      className={address.defaultAddress ? "fill-current" : ""}
                    />
                  </button>
                  <Link to={`/account/billing`} state={address}>
                    <button
                      className="p-1 text-blue-500 hover:text-blue-700"
                      title="Edit"
                    >
                      <Edit />
                    </button>
                  </Link>
                  <button
                    onClick={() => handleDelete(address.rowId)}
                    className="p-1 text-red-500 hover:text-red-700"
                    title="Delete"
                  >
                    <BsFillTrash2Fill />
                  </button>
                </div>
              </div>

              <address className="not-italic mb-3">
                <p className="font-medium">
                  {/* {address.firstName} {address.lastName} */}
                </p>
                <p>{address.address}</p>
                {address.apartment && <p>{address.apartment}</p>}
                <p>
                  {address.city}, {address.state} {address.postalCode}
                </p>
                <p>{address.country}</p>
                {address.phone && <p>Phone: {address.phone}</p>}
                {/* {address.email && <p>Email: {address.email}</p>} */}
              </address>

              <div className="flex justify-between items-center text-xs text-gray-500">
                <span>Created: {formatDate(address.CREATEDTIME)}</span>
                {address.defaultAddress && (
                  <span className="text-blue-500">
                    Default for {address.addressType.toLowerCase()}
                  </span>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-2 text-center py-8">
            <MapPin className="mx-auto text-gray-400 text-4xl mb-2" />
            <p className="text-gray-600">You haven't saved any addresses yet</p>
            <Link to="/account/billing">
              <button className="mt-4 bg-[#034C8C] hover:bg-green-700 text-white px-4 py-2 rounded">
                Add Your First Address
              </button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
